import { Grid } from '@material-ui/core';
import React from 'react';
import BaseButton from 'src/common/components/base-button';
import { pushEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { IItemLookup } from 'src/common/interfaces/dtos/IItemLookup';
import { IButton } from 'src/common/interfaces/IButton';
import Keypad from 'src/keypad/components/keypad';
import { styles } from './bottle-deposit-quantity-modal-styles';
import { IKeypadModal, KeypadModal } from 'src/common/components/keypad-modal/keypad-modal';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { useTranslation } from 'react-i18next';
import { UomText } from 'src/common/enumerations/unit-of-measure-type';

export const showBottleDepositQuantityDialog = (
  props: IBottleDepositQuantityProps,
  modalId: string,
) => {
  pushEmeraldModal(<BottleDepositQuantityModal {...props} />, undefined, modalId);
};

const BottleDepositQuantityModal = ({
  onClose,
  onApprove,
  selectedItem,
}: IBottleDepositQuantityProps): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();
  const { regularSalesUnitPrice, itemId, description } = selectedItem;

  const keypadSubmitButton: IButton = {
    label: 'OK',
    onClick: onApprove,
  };

  const keypadModal: IKeypadModal = {
    onClose: onclose,
    title: '',
    buttonComponent: (
      <Grid item>
        <BaseButton
          buttonType='white'
          className={classes.rejectButton}
          data-testid='bottle-deposit-quantity-cancel-button'
          onClick={onClose}
        >
          <span className='label'>{t('Cancel_Button')}</span>
        </BaseButton>
      </Grid>
    ),
    contentArea: (
      <Grid item xs={11} className={classes.container}>
        <Grid container justifyContent='center' direction='column' alignItems='center'>
          <Grid item className={classes.title} data-testid='bottle-deposit-quantiity-title'>
            {t('BottleDepositTitle')}
          </Grid>
          <Grid item data-testid='bottle-deposit-quantiity-subtitle'>
            <h4 className={styles().subBarText}>{t('BottleDepositQuantityMessage')}</h4>
          </Grid>
        </Grid>
        <Grid item className={classes.message}>
          <Grid container direction='column' alignItems='flex-start'>
            <Grid item data-testid='item-description' className={classes.contentItemNameSubText}>
              {description}
            </Grid>
            <Grid item data-testid='item-id' className={classes.contentItemCodeSubText}>
              {itemId}
            </Grid>
            <Grid item data-testid='item-price' className={classes.contentItemCodeSubText}>
              <span className={classes.currencyText}>
                {convertCurrency(regularSalesUnitPrice?.price.value ?? 0)}
              </span>{' '}
              / {UomText.EA}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    ),
    keypad: (
      <Keypad
        keyboardId={'bottle-deposit-quantity'}
        visible
        keypadTestIdPrefix={'bottle-deposit-quantity-'}
        topLabelText={t('EnterQuantityInKeypad')}
        submitButton={keypadSubmitButton}
        disableManualWeight={true}
        disableQuantity={true}
        disableDecimalInput={true}
        disableSubmitWhenNoInput={true}
      />
    ),
  };

  return <KeypadModal {...keypadModal} />;
};

export interface IBottleDepositQuantityProps {
  onClose: () => void;
  onApprove: (quantity: string) => void;
  selectedItem: IItemLookup;
}

export default BottleDepositQuantityModal;
